import React from 'react';
import TabNavigator from '../TabNavigator';
import PageHeader, { PageHeaderProps } from '../PageHeader';
import Animated from '../AnimatedComponent';
import { CONSTANTS } from '../../common/config/constants';

interface ScreenProps {
  children: any;
  className?: string;
  screenContainerClassName?: string;
  screenOptions?: {
    showTabNavigator?: boolean;
    header?: PageHeaderProps;
    tabNavigator?: {
      hide?: boolean;
    };
  };
}

const Screen = ({ children, screenOptions, className, screenContainerClassName }: ScreenProps) => {
  const contentHeight =
    (screenOptions?.tabNavigator?.hide === undefined
      ? 100 - CONSTANTS.headerHeight - CONSTANTS.tabNavigatorHeight
      : 100 - CONSTANTS.headerHeight) + 'vh';
  return (
    <div className={`w-full h-screen bg-[#f2f2f7] dark:bg-black ${screenContainerClassName}`}>
      <div
        style={{
          height: `${CONSTANTS.headerHeight}vh`,
          maxHeight: `${CONSTANTS.headerHeight}vh`,
          minHeight: `${CONSTANTS.headerHeight}vh`,
        }}
      >
        <PageHeader {...screenOptions?.header} />
      </div>
      <Animated.Screen
        style={{ height: contentHeight, maxHeight: contentHeight, minHeight: contentHeight }}
        className={`overflow-hidden ${className}`}
      >
        {children}
      </Animated.Screen>
      {screenOptions?.tabNavigator?.hide === undefined && (
        <div
          style={{
            height: `${CONSTANTS.tabNavigatorHeight}vh`,
            maxHeight: `${CONSTANTS.tabNavigatorHeight}vh`,
            minHeight: `${CONSTANTS.tabNavigatorHeight}vh`,
          }}
          className='px-4 py-3'
        >
          <TabNavigator />
        </div>
      )}
    </div>
  );
};

export default Screen;
